import { getSectionStyle } from "@/utils";
import { getPageRoute, getS3ImageUrl } from "@/utils/routes";
import Image from "next/image";
import Link from "next/link";
import classes from "./ShowBannersSection.module.css";

interface Props extends WidgetSectionProps {
	section?: boolean;
}

const SmallWideBanner = ({ section = true, widget }: Props) => {
	const settings = widget?.data?.settings || {};
	const left = settings?.position !== "right";
	const gap = settings?.gap || 16;

	const classNames = [classes.ShowBannersSection, classes.smallWide];
	if (section) classNames.push(classes.section);
	classNames.push(classes.small);

	const banners = widget?.data?.images || [];

	if (banners.length === 0) return null;

	return (
		<div className={classNames.join(" ")} style={getSectionStyle(settings)}>
			<div
				className={
					settings?.containerType === "full" ? "" : "container"
				}>
				<div
					className={classes.contents}
					style={
						{
							display: "flex",
							justifyContent: "space-between",
						} as React.CSSProperties
					}>
					{banners.map((banner, index) => {
						let classNames = `${classes.banner}`;

						let height = settings?.height || 400;

						const width = left
							? `calc(${index === 0 ? "30" : "70"}% - ${
									gap / 2
							  }px)`
							: `calc(${index === 0 ? "70" : "30"}% - ${
									gap / 2
							  }px)`;

						return (
							<div
								className={classNames}
								key={banner.image || banner.link?.url || `small-banner-${index}`}
								title={banner.link?.hyperLinkText}
								style={{
									height: height + "px",
									flex: "0 0 " + width,
								}}>
								<Link
									href={getPageRoute(
										banner.link?.urlType || "custom",
										banner.link?.url || ""
									)}
									className={!banner.link ? "no-link" : ""}
									style={{
										display: "block",
										width: "100%",
										height: "100%",
									}}>
									<Image
										src={getS3ImageUrl(banner.image)}
										alt={
											banner.link?.hyperLinkText ||
											"Banner"
										}
										blurDataURL={
											"https://www.unfe.org/wp-content/uploads/2019/04/SM-placeholder.png"
										}
										placeholder="blur"
										layout="fill"
										unoptimized={true}
										style={{
											objectFit: (settings?.objectFit ||
												"cover") as any,
										}}
									/>
								</Link>
							</div>
						);
					})}
				</div>
			</div>
		</div>
	);
};

export default SmallWideBanner;
